<!-- Loading overlay -->
<div *ngIf="loading" class="loading-overlay">
  <mat-spinner></mat-spinner>
</div>

<div class="mx-auto max-w-screen-2xl py-32 md:py-14 lg:px-32">
  <!-- Header -->
  <div class="mb-12">
    <span class="mat-display-2 mb-0 font-bold text-dark-green"
      >Manage cars</span
    >
  </div>

  <!-- Search -->
  <div
    class="mb-6 flex flex-col items-center justify-between gap-4 md:flex-row"
  >
    <div class="w-full md:w-[350px]">
      <app-custom-search-field
        [(ngModel)]="searchTerm"
        (ngModelChange)="applyFilter()"
        [placeholder]="'Keresés'"
        [ariaLabel]="'Keresés'"
        maxWidth="100%"
      ></app-custom-search-field>
    </div>
  </div>

  <!-- Table Card -->
  <mat-card class="mat-elevation-z0 rounded-2xl md:p-14">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 w-full">
      <!-- Column 1: Car Name (Always visible) -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Jármű neve</th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <!-- Column 2: Category (Desktop only) -->
      <ng-container matColumnDef="category">
        <th mat-header-cell *matHeaderCellDef class="hidden md:table-cell">
          Kategória
        </th>
        <td mat-cell *matCellDef="let element" class="hidden md:table-cell">
          {{ element.category }}
        </td>
      </ng-container>

      <!-- Column 3: Make (Desktop only) -->
      <ng-container matColumnDef="make">
        <th mat-header-cell *matHeaderCellDef class="hidden md:table-cell">
          Márka
        </th>
        <td mat-cell *matCellDef="let element" class="hidden md:table-cell">
          {{ element.make }}
        </td>
      </ng-container>

      <!-- Column 4: Model (Desktop only) -->
      <ng-container matColumnDef="model">
        <th mat-header-cell *matHeaderCellDef class="hidden md:table-cell">
          Típus
        </th>
        <td mat-cell *matCellDef="let element" class="hidden md:table-cell">
          {{ element.model }}
        </td>
      </ng-container>

      <!-- Column 5: Characteristics (Desktop only) -->
      <ng-container matColumnDef="characteristics">
        <th mat-header-cell *matHeaderCellDef class="hidden md:table-cell">
          Jellemzők
        </th>
        <td mat-cell *matCellDef="let element" class="hidden md:table-cell">
          <div class="flex items-center gap-3">
            <!-- Seats -->
            <div
              class="flex h-fit items-center gap-1 rounded-full border px-3 py-2"
              [ngClass]="{
                'text-customRed-300': element.numberOfSeats === undefined,
                'text-dark-green': element.numberOfSeats !== undefined
              }"
            >
              <mat-icon class="h-5 w-5 text-[20px]"> event_seat </mat-icon>
              <span class="inline-block h-fit text-sm">
                {{
                  element.numberOfSeats !== undefined
                    ? element.numberOfSeats
                    : "-"
                }}
              </span>
            </div>

            <div class="flex w-[100px] items-center gap-2 rounded-full border px-3 py-2"
              [ngClass]="{
                'text-customRed-300':
                  element.largeLuggageCapacity === undefined &&
                  element.smallLuggageCapacity === undefined,
                'text-dark-green':
                  element.largeLuggageCapacity !== undefined ||
                  element.smallLuggageCapacity !== undefined
              }"
            >
              <!-- Large Luggage -->
              <div
                class="flex h-fit items-center gap-1"
                [ngClass]="{
                  'text-customRed-300':
                    element.largeLuggageCapacity === undefined,
                  'text-dark-green': element.largeLuggageCapacity !== undefined
                }"
              >
                <mat-icon
                  [class.text-customRed-300]="
                    element.largeLuggageCapacity === undefined
                  "
                  [class.text-dark-green]="
                    element.largeLuggageCapacity !== undefined
                  "
                  class="h-5 w-5 text-[20px]"
                >
                  luggage
                </mat-icon>
                <span
                  class="inline-block h-fit text-sm"
                  [class.text-customRed-300]="
                    element.largeLuggageCapacity === undefined
                  "
                  [class.text-dark-green]="
                    element.largeLuggageCapacity !== undefined
                  "
                >
                  {{
                    element.largeLuggageCapacity !== undefined
                      ? element.largeLuggageCapacity
                      : "-"
                  }}
                </span>
              </div>
              <div
                class="flex h-fit items-center gap-1"
                [ngClass]="{
                  'text-customRed-300':
                    element.smallLuggageCapacity === undefined,
                  'text-dark-green': element.smallLuggageCapacity !== undefined
                }"
              >
                <!-- Small Luggage -->
                <mat-icon
                  [class.text-customRed-300]="
                    element.smallLuggageCapacity === undefined
                  "
                  class="h-5 w-5 text-[20px]"
                >
                  work
                </mat-icon>
                <span
                  class="inline-block h-fit text-sm"
                  [class.text-customRed-300]="
                    element.smallLuggageCapacity === undefined
                  "
                >
                  {{
                    element.smallLuggageCapacity !== undefined
                      ? element.smallLuggageCapacity
                      : "-"
                  }}
                </span>
              </div>
            </div>

            <!-- Transmission Chip -->
            <div
              class="flex items-center gap-1 rounded-full border border-dark-green px-3 py-2 text-sm"
              [class.text-dark-green]="element.transmission !== undefined"
              [class.w-[120px]]="element.transmission !== undefined"
              [class.text-customRed-300]="element.transmission === undefined"
              [class.border-customRed-300]="element.transmission === undefined"
            >
              <mat-icon
                [class.text-customRed-300]="
                  element.transmission === undefined
                "
                class="h-5 w-5 text-[20px]"
              >
                settings
              </mat-icon>
              {{ getTransmissionLabel(element.transmission) }}
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Column 6: Image Status (Always visible) -->
      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef class="w-16">Kép</th>
        <td mat-cell *matCellDef="let element" class="w-16">
          <mat-icon
            [class.text-customRed-300]="hasImageError(element)"
            [class.text-light-gray]="!hasImageError(element)"
            class="h-5 w-5 text-[20px]"
          >
            image
          </mat-icon>
        </td>
      </ng-container>

      <!-- Column 7: Actions (Always visible) -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="w-16 md:w-44"></th>
        <td mat-cell *matCellDef="let element" class="w-16 md:w-44">
          <button
            mat-button
            color="primary"
            (click)="openEditDialog(element)"
            class="rounded-xl py-1 px-4 text-base font-bold"
          >
            <mat-icon color="primary" class="material-icons-outlined"
              >edit</mat-icon
            >
            <span class="hidden h-fit md:inline-block">Módosítás</span>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- Empty State -->
    <div
      *ngIf="dataSource.data.length === 0"
      class="flex h-96 flex-col items-center justify-center"
    >
      <img
        alt="No results"
        src="../../../assets/figures/man-questioning.svg"
        class="mb-2 h-[88px]"
      />
      <p class="text-lg font-bold">Nincs találat</p>
      <p class="inline-block h-fit text-sm">
        {{
          searchTerm
            ? "Próbálj meg más keresési kifejezést."
            : "Nincs elérhető jármű."
        }}
      </p>
    </div>
  </mat-card>

  <!-- Pagination -->
  <mat-paginator
    *ngIf="dataLength > 0"
    [length]="dataLength"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="pageIndex"
    (page)="onPagination($event)"
    class="mt-6 rounded-2xl"
  >
  </mat-paginator>
</div>
